import React from 'react';
import { Typography, Card, Divider, Space } from 'antd';
import { QuizQuestionAnswer } from "src/data/models/quiz/QuizQuestionResultModel";
import { useDarkMode } from 'src/context/DarkModeContext';

const { Title, Text } = Typography;

interface QuizMistakesOverviewProps {
    incorrectAnswers: QuizQuestionAnswer[];
}

const QuizMistakesOverview: React.FC<QuizMistakesOverviewProps> = ({
    incorrectAnswers,
}) => {
    const { isDarkMode } = useDarkMode();

    const cardBg = isDarkMode ? '#2b2b2b' : '#ffffff';
    const highlight = isDarkMode ? '#ff4d4f' : '#cf1322';
    const textColor = isDarkMode ? '#ffffff' : '#000000';

    if (incorrectAnswers.length === 0) return <></>;

    const renderExplanation = (incorectAnswer: QuizQuestionAnswer): React.ReactNode => {
        let explanation = incorectAnswer.question.explanation;
        return explanation && (
            <Text style={{ fontStyle: 'italic', color: textColor }}>
                💡 {explanation}
            </Text>
        )
    }

    const generateCardPerAnswer = (): React.ReactNode => {
        return incorrectAnswers.map((incorectAnswer, index) => {
            return (
                <Card
                    key={index}
                    style={{
                        backgroundColor: cardBg,
                        border: `1px solid ${highlight}`,
                        borderRadius: 10,
                        padding: 16,
                        textAlign: 'left',
                        boxShadow: isDarkMode
                            ? '0 2px 8px rgba(0, 0, 0, 0.6)'
                            : '0 2px 8px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Text strong style={{ color: textColor }}>
                        Q: {incorectAnswer.question.questionText}
                    </Text>
                    <br />

                    <Text type="danger">Your Answer: {incorectAnswer.getUserAnswer()}</Text>
                    <br />

                    <Text type="success">Correct Answer: {incorectAnswer.getCorrectAnswer()}</Text>

                    <Divider style={{ margin: '10px 0' }} />

                    {renderExplanation(incorectAnswer)}
                </Card>
            );
        })
    }

    return (
        <div>
            <Title level={4} style={{ color: highlight }}>
                Incorrect Answers
            </Title>

            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {generateCardPerAnswer()}
            </Space>
        </div>
    )
};

export default QuizMistakesOverview;